module.exports = "/fonts/fa-brands-400.svg?6be0d28532facdddf7153ae18175dd05";